import axios from 'axios';

const API_BASE =process.env.REACT_APP_API_BASE_URL

console.log('API_BASE:', API_BASE);
console.log('NODE_ENV:', process.env.NODE_ENV);

export async function getBookingReports(params = {}) {
  try {
    const response = await axios.get(`${API_BASE}/api/reports/bookings`, {
      params,
      headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      throw error.response.data;
    }
    throw new Error('Failed to fetch booking reports');
  }
}

export async function getTransactionReports(params = {}) {
  try {
    const response = await axios.get(`${API_BASE}/api/reports/transactions`, {
      params,
      headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      throw error.response.data;
    }
    throw new Error('Failed to fetch transaction reports');
  }
}

export async function getCancelledBookings(params = {}) {
  try {
    const url = `${API_BASE}/api/reports/cancelledBookings`;
    console.log('Making API call to:', url);
    console.log('With params:', params);

    const response = await axios.get(url, {
      params,
      headers: { 'Content-Type': 'application/json' }
    });

    console.log('API response received:', response.data);
    return response.data;
  } catch (error) {
    console.error('API call failed:', error);
    if (error.response?.data) {
      throw error.response.data;
    }
    throw new Error('Failed to fetch cancelled bookings');
  }
}

export async function getBookingCommission(params = {}) {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_BASE}/api/reports/bookingCommission`, {
      params,
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` })
      }
    });
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      throw error.response.data;
    }
    throw new Error('Failed to fetch booking commission');
  }
}

export async function getCustomerTransactionLedger(params = {}) {
  try {
    const response = await axios.get(`${API_BASE}/api/reports/getCustomerTransactionLedger`, {
      params,
      headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      throw error.response.data;
    }
    throw new Error('Failed to fetch customer transaction ledger');
  }
}

export async function getLeadReport(params = {}) {
  try {
    const response = await axios.get(`${API_BASE}/api/reports/getLeadReport`, {
      params,
      headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      throw error.response.data;
    }
    throw new Error('Failed to fetch lead report');
  }
}

export async function getProjectReport(params = {}) {
  try {
    const response = await axios.get(`${API_BASE}/api/reports/getProjectReport`, {
      params,
      headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      throw error.response.data;
    }
    throw new Error('Failed to fetch project report');
  }
}

export async function getDayBookReport(params = {}) {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_BASE}/api/reports/dayBook`, {
      params,
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` })
      }
    });
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      throw error.response.data;
    }
    throw new Error('Failed to fetch day book report');
  }
}

export async function getSiteVisitReport(params = {}) {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_BASE}/api/reports/getSiteVisitReport`, {
      params: {
        ...params,
        search: params.search || params.searchTerm || params.filterKey
      },
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` })
      }
    });
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      throw error.response.data;
    }
    throw new Error('Failed to fetch site visit report');
  }
}


